import ErrorDetailModal from './errorDetail';

export default ErrorDetailModal;